import type { IconSvgObject } from './types';

const UnfoldMoreIcon: IconSvgObject = [
  ["path", { d: "M18 9.99996L12 4.5L6 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 14L12 19.5L6 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default UnfoldMoreIcon;
